const hy = {
  loadingTypes: {
    notSpecified: 'նշված չէ',
  },
};

export { hy };
